exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card-layout-for-world-map{position:relative;width:100%;height:100%}.main{width:100%;height:100%}.bottom{position:absolute;bottom:20px;width:80%;height:30px;z-index:99;left:10%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-fc1beb1e!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layouts/world-map-layout/index.vue
// module id = 181
// module chunks = 0